import React from 'react'
import { Button } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight, faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import { useGhgCalculatorFormContext } from './use-ghg-calculator-form'
import { UseFormMethods } from 'react-hook-form'

export const GhgCalculatorNavigation = (props: {
  handleSubmit?: UseFormMethods['handleSubmit']
  children?: React.ReactNode
}) => {
  const { handleSubmit, children } = props
  const { nextStep, goToNextStep, previousStep, goToPreviousStep } = useGhgCalculatorFormContext()

  return (
    <div className="d-flex justify-content-end mt-5 mb-4">
      {previousStep ? (
        <Button
          onClick={
            handleSubmit
              ? handleSubmit(() => {
                  goToPreviousStep()
                })
              : goToPreviousStep
          }
          variant="secondary btn-lg"
          className="mr-3"
        >
          <FontAwesomeIcon icon={faArrowLeft} className="btn-icon-left" />
          {previousStep.title}
        </Button>
      ) : (
        <div />
      )}
      {nextStep ? (
        <Button
          onClick={
            handleSubmit
              ? handleSubmit(() => {
                  goToNextStep()
                })
              : goToNextStep
          }
          variant="primary btn-lg"
        >
          {nextStep.title}
          <FontAwesomeIcon icon={faArrowRight} className="btn-icon-right" />
        </Button>
      ) : (
        <div />
      )}
      {children}
    </div>
  )
}
